import el from '@finn-no/create-element';
export default {
    dependencies: ['$element', 'radio', 'trackingservice'],
    callable(ele, radio, trackingService) {
        radio('save-search-success').subscribe(displayDownloadNativeApp);
        function displayDownloadNativeApp() {
            if (!ele.classList.contains('hidden')) {
                return;
            }
            const isAndroid = /Android/i.test(navigator.userAgent);
            const isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            if (!isAndroid && !isIos) {
                return;
            }
            let downloadAppElement;
            if (isAndroid) {
                downloadAppElement = createDownloadAndroidAppElement();
            } else if (isIos) {
                downloadAppElement = createDownloadIosAppElement();
            }
            ele.style.opacity = '0';
            ele.classList.remove('hidden');
            ele.style.transition = 'opacity 0.6s';
            ele.appendChild(downloadAppElement);
            window.requestAnimationFrame(() => {
                ele.style.opacity = '1';
            });
        }
        function removeDisplayDownloadNativeApp() {
            ele.remove(); // user has discarded the app banner, no need to keep it around
        }
        function createDownloadAndroidAppElement() {
            // TODO: Use static.finncdn.no
            const logoSrc = '/static/images/play_store_badge_optimized.svg';
            const caption = 'Last ned App fra Google Play';
            const downloadUrl =
                'https://play.google.com/store/apps/details?' +
                'id=no.finn.android&referrer=utm_source%3Dmfinn%26utm_medium%3Dweb%26utm_campaign%3Dmfinn-result-list';
            return createDownloadAppElementWith(logoSrc, caption, downloadUrl);
        }
        function createDownloadIosAppElement() {
            // TODO: Use static.finncdn.no
            const logoSrc = '/static/images/badge_appstore_lrg_optimized.svg';
            const caption = 'Last ned App fra App Store';
            const downloadUrl =
                'https://itunes.apple.com/app/apple-store/id526541908?pt=295309&ct=mfinn-result-list&mt=8';
            return createDownloadAppElementWith(logoSrc, caption, downloadUrl);
        }
        function trackGoToAppStore() {
            trackingService.trackEventObject({
                analyticsName: 'promotion.go-to-app-store.click',
                eventFlags: 'start,ltp',
                stringValue: 'result-list',
            });
        }
        function createDownloadAppElementWith(logoSrc, caption, downloadUrl) {
            return el(
                'div.inner',
                null,
                el(
                    'button.fright.pan.small.blank',
                    { type: 'button', onclick: removeDisplayDownloadNativeApp },
                    el(
                        'svg:svg',
                        {
                            width: '25',
                            height: '25',
                            viewBox: '0 0 22 22',
                            style: 'float:right;opacity:0.5',
                        },
                        // eslint-disable-next-line max-len
                        el('svg:path', {
                            fill: '#04253C',
                            d:
                                'M15.3 15.3c-.45.45-1.116.385-1.5 0L11 12.5l-2.8 2.8c-.385.385-1.063.437-1.5 0-.367-.367-.385-1.114 0-1.5L9.5 11 6.7 8.2c-.385-.385-.414-1.086 0-1.5.387-.387 1.115-.384 1.5 0L11 9.5l2.8-2.8c.384-.385 1.09-.408 1.5 0 .428.43.384 1.115 0 1.5L12.5 11l2.8 2.8c.385.386.435 1.064 0 1.5z',
                        })
                    )
                ),
                el(
                    'div.bd',
                    null,
                    el('h3', null, 'Bli varslet med en gang!'),
                    el(
                        'p',
                        null,
                        'Nå kan du få umiddelbar varsling på mobilen eller nettbrettet ' +
                            'hver gang noen legger ut en ny annonse som passer ditt søk!'
                    ),
                    el(
                        'p.centerify',
                        null,
                        el(
                            'a',
                            { href: downloadUrl, onclick: trackGoToAppStore },
                            el('img', {
                                style: 'height:40px;',
                                alt: caption,
                                src: logoSrc,
                            })
                        )
                    )
                )
            );
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/downloadNativeApp.js